import React, { useState } from "react";
import { connect } from "dva";
import { useTranslation } from "react-i18next";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import "./index.less";
import { changeEgovUrl } from "@/utils/tools";

const AiSolitaireCard = connect(
  function () {
    return {};
  },
  function (dispatch: any) {
    return {
      openSolitaireDetails(data: { isvisibles: boolean; solitaire: any }) {
        dispatch({ type: "chat/openSolitaireDetails", payload: data });
      }
    };
  }
)(
  ({
    message,
    openSolitaireDetails
  }: {
    message: any;
    openSolitaireDetails: (data: { isvisibles: boolean; solitaire: any }) => void;
  }) => {
    const { title, extend } = message;
    const [t] = useTranslation("chat");
    const handleOpen = () => {
      openSolitaireDetails({
        isvisibles: true,
        solitaire: message.infox.solitaireId
      });
    };
    return (
      <ComNoticeCard
        message={message}
        avatarSrc={changeEgovUrl(message.sender.avatar)}
        type="组接龙"
        contentList={extend.fields}
        title={title}
        handleDetail={handleOpen}
        loadButtonsFn={() => (
          <div
            className="button_item"
            onClick={() => {
              handleOpen();
            }}
          >
            <span>{t("click-to-view")}</span>
          </div>
        )}
      />
    );
  }
);

export default AiSolitaireCard;
